import { render, staticRenderFns } from "./UserNotificationsCard.vue?vue&type=template&id=0671212f&scoped=true&"
import script from "./UserNotificationsCard.vue?vue&type=script&lang=js&"
export * from "./UserNotificationsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0671212f",
  null
  
)

export default component.exports